export default __webpack_public_path__ + "static/1-624018e3708c66843b529d6bd0a01002.jpg";